import React from 'react'
import './style.css'

export default function TextInputFilter({ input, setInput, type = "text", placeholder = "" }) {
  return (
    <input className="text-input-filter" type={type} value={input} placeholder={placeholder} onChange={(e) => { setInput(e.target.value) }} />
  )
}